module.exports = __webpack_public_path__ + "static/media/11.59272d9c.svg";